/**
 * Created by simonhutton on 12/06/15.
 */

import $ from "jquery";
import _ from "underscore";

export function preventDefault(event) {
    if (event != null) {
        event.preventDefault();
    }
}

function compactDate(date) {
    var m = moment.utc(date).local();

    if (moment().isSame(m, 'day')) {
        return m.format("h:mm a");
    } else if (moment().diff(m, 'year') === 0) {
        return m.format("MMM D");
    } else {
        return m.format("MMM D 'YY");
    }
}

function compactDateWithTime(date) {
    if (!date){
        return "-";
    }

    var m = moment.utc(date).local();

    if (moment().isSame(m, 'day')) {
        return m.format("h:mm a");
    } else if (moment().diff(m, 'year') === 0) {
        return m.format("MMM D @ h:mm a");
    } else {
        return m.format("MMM D 'YY @ h:mm a");
    }
}

function compactDateWithTimeSmart(date) {
    if (!date){
        return "-";
    }

    var m = moment.utc(date).local();

    if (moment().isSame(m, 'day')) {
        return m.format("h:mm a");
    } else if (moment().diff(m, 'year') === 0) {
        return m.format("MMM D, h:mm a");
    } else {
        return m.format("MMM D 'YY, h:mm a");
    }
}

function compactDateWithTimeAndSeconds(date) {
    var m = moment.utc(date).local();

    if (moment().isSame(m, 'day')) {
        return m.format("H:mm:ss");
    } else if (moment().diff(m, 'year') === 0) {
        return m.format("MMM D @ H:mm:ss");
    } else {
        return m.format("MMM D 'YY @ H:mm:ss");
    }
}

function longDynamicDateWithTime(date) {
    var m = moment.utc(date).local();

    if (moment().isSame(m, 'day')) {
        return "Today " + m.format("h:mm a");
    } else if (moment().add(-1, 'days').isSame(m, 'day')) {
        return "Yesterday " + m.format("h:mm a");
    } else if (moment().diff(m, 'year') === 0) {
        return m.format("MMM DD h:mm a");
    } else {
        return m.format("MMM DD 'YY h:mm a");
    }
}

function fromNowDateTime(date) {
    var m = moment.utc(date).local();

    return m.fromNow();
}

function longFormDateWithTime(date) {
    var m = moment.utc(date).local();

    return m.format("dddd, Do MMMM YYYY h:mm a");
}

function longFormDate(date) {
    var m = moment.utc(date).local();

    return m.format("dddd, Do MMMM YYYY");
}

function fullDateWithTime(date) {
    var m = moment.utc(date).local();

    return m.format("dddd MMM Do, h:mm a");
}

function timestamp() {
    var m = moment.utc().local();

    return m.format("YYYY-MM-DD_HH-mm");
}

export function isValidEmail(email) {
    if (!email){
        return false;
    }

    if (email.indexOf(' ') !== -1) {
        return false;
    }

    var indexOfAt = email.indexOf('@');

    if (indexOfAt < 1) {
        return false;
    }

    if (email.split("@").length > 2){
        return false;
    }

    if (email.slice(indexOfAt, email.length - 1).indexOf('.') === -1) {
        return false;
    }

    if (email.indexOf('..') !== -1){
        return false;
    }

    if (endsWith(email, ".")){
        return false;
    }

    return true;
}

function isWildCard(email){
    if (email.startsWith("*")){
        return true;
    }

    if (email.endsWith("*")){
        return true;
    }

    return false;
}

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}

function duplicateCount(list) {
    var counts = {};
    var duplicates = 0;

    list.forEach(function (x) {
        counts[x] = (counts[x] || 0) + 1;
    });

    for (var key in counts) {
        if (counts[key] > 1) {
            duplicates++;
        }
    }

    return duplicates;
}

function isPasswordStrongEnough(password){
    return scorePassword(password) > 60;
}

function scorePassword(pass) {
    var score = 0;
    if (!pass)
        return score;

    // award every unique letter until 5 repetitions
    var letters = {};
    for (var i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
    }

    // bonus points for mixing it up
    var variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass),
    }

    var variationCount = 0;
    for (var check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;

    return parseInt(score);
}

function checkPassStrength(pass) {
    var score = scorePassword(pass);

    if (score > 80)
        return "Strong";
    if (score > 60)
        return "Good";

    return "Weak";
}

function replyToMessageFormat(date) {
    var m = moment.utc(date).local();

    return m.format("D MMM YYYY") + ", at " + m.format("HH:mm");
}

function removeFromArray(arr, item) {
    for (var i = arr.length; i--;) {
        if (arr[i] === item) {
            arr.splice(i, 1);
        }
    }
}

export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

if ((typeof Fingerprint2 !== 'undefined')){
    try{
        new Fingerprint2().get(function(result, components){
            window.identityToken = result;
        });

    } catch(e) {
        console.log(e);
        window.identityToken = 'error';
    }
} else {
    window.identityToken = 'not loaded';
}

function getIdentifierToken(){
    return window.identityToken;
}

function whenIdentifierTokenReady(callback){
    if (_.isUndefined(getIdentifierToken())){
        _.delay(function(){
            whenIdentifierTokenReady(callback);
        }, 50);
    } else {
        callback(getIdentifierToken());
    }
}

function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    if (bytes == 0){
      return '0 Bytes';
    }

    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

function applyPercentOff(total, percentOff){
    if (percentOff === 0){
        return total;
    }

    return total - (total * (percentOff / 100.0));
}

function applyTax(total, taxRate) {
    if (taxRate === 0){
        return total;
    }

    return total + (total * (taxRate / 100.0));
}

function sanitise_name(name){
    var sanitised_name = name.replace(/[^0-9a-zA-Z-_.]/gi, '-').replace(/--+/g, '-');

    return sanitised_name.toLowerCase();
}

function startToast(message, timeout){
    var saveId = guid();

    if (_.isUndefined(timeout)){
        timeout = 30 * 1000;
    } else {
        timeout = timeout * 1000;
    }

    Materialize.toast('<span id="' + saveId + '">' + message + '</span>', timeout);

    return saveId;
}

function concludeToast(elementName, message){

    var toastEl = $('#' + elementName);

    toastEl.html(message)

    _.delay(function(){
        toastEl.parent().remove();
    }, 1000);
}

function cancelToast(saveId){
    $('#' + saveId).parent().remove();
}

function failedToast(message, timeout) {
    if (_.isUndefined(timeout)){
        timeout = 4 * 1000;
    } else {
        timeout = timeout * 1000;
    }

    Materialize.toast(message, timeout, "materialize-red lighten-2");
}

function cancelShowFailedToast(saveId, message, timeout) {
    cancelToast(saveId);
    failedToast(message, timeout);
}

function smartFormatCost(cost, includeCurrency, fractionDigits) {
    if (cost > 100){
        return formatCost(cost, includeCurrency, 0);
    } else {
        return formatCost(cost, includeCurrency, fractionDigits);
    }
}

function formatCost(cost, includeCurrency, fractionDigits){
    if (_.isUndefined(fractionDigits)){
        fractionDigits = 2;
    }

    if (_.isUndefined(includeCurrency)){
        includeCurrency = true;
    }

    if (cost % 1 !== 0){
        cost = cost.toFixed(fractionDigits);
    }

    if (isNaN(cost)){
        return "-";
    }

    if (includeCurrency){
        return "$" + numberWithCommas(cost);
    } else {
        return numberWithCommas(cost);
    }

}

function save_user_setting(settingName, value, successCallback, failureCallback){
        $.ajax({
            type: "POST",
            url: '/list/user-setting',
            data: {list_id: window.ManageView.settingsModel.get('id'),
                    settingName: settingName,
                    value: value},
            success: function(response){
                if (!_.isUndefined(successCallback)){
                    successCallback();
                }
            },
            fail: function(jqXHR){
                if (!_.isUndefined(failureCallback)){
                    failureCallback();
                }
            }
        });

}

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function(search, pos) {
		return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
	};
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}

String.prototype.getHashCode = function() {
    var hash = 0;
    if (this.length === 0) return hash;
    for (var i = 0; i < this.length; i++) {
        hash = this.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
Number.prototype.intToHSL = function() {
    var shortened = this % 360;
    var granularity = 10;

    shortened = Math.ceil(shortened / granularity) * granularity;

    return "hsl(" + shortened + ", 42%, 51%)";
};

function colorFromString(value){
    if (!value){
        return 'hsl(0deg 0% 86%)';
    }

    return value.getHashCode().intToHSL();
}

function pluralise(count, word, suffix){
	if (count === 1){
		return word;
	} else {
		suffix = (typeof suffix === 'undefined') ? 's' : suffix;

		return word + suffix;
	}
}

function extractInitials(name){
    if (!Boolean(name))
	{
		return "?";
	}

    name = name.replace(/<\/?[^>]+(>|$)/g, "");

	if (!Boolean(name))
	{
		return "?";
	}

	name = name.toUpperCase().trim();

	name = name.replace(".", "");

	name = name.replace(/(DR|JR|SIR)\b\b/g, "");

	name = name.replace(/ *\([^)]*\) */g, "");

	name = name.replace(/-[a-zA-Z]{1,5}\+[a-zA-Z\[\]]*/g, "");

	if (!Boolean(name))
	{
		return "?";
	}

	if (name.indexOf(',') !== -1){
		var parts = name.split(',');

		name = parts[1] + " " + parts[0];

        name = name.toUpperCase().trim();
	}

	if (name.length === 2){
		return name;
	}

    var names = name.split(' ');
    var initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
}

function sanitiseText(text) {
    var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;

    while (SCRIPT_REGEX.test(text)) {
        text = text.replace(SCRIPT_REGEX, "");
    }

    return text;
}

function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

function forceReload() {
    window.location.reload();
}

$.fn.isWithinParent = function(parent, offset) {
    if (_.isUndefined(offset)){
        offset = 10;
    }

    var elementBottom = $(this).offset().top + $(this).outerHeight();

    var parentTop = parent.offset().top;

    return elementBottom - offset > parentTop;
};

function reportScrollPositions(el){
    console.log("<" + el.prop("tagName") + " ." + el.attr("class") + " #" + el.attr("id") + "> - " + "clientHeight=" + el[0].clientHeight + " offsetHeight=" + el[0].offsetHeight + " scrollHeight=" + el[0].scrollHeight + " scrollTop=" + el.scrollTop());

    var parent = el.parent();

    if (parent.length > 0){
        reportScrollPositions(parent);
    }
}

Array.prototype.findIndex = Array.prototype.findIndex || function(callback) {
  if (this === null) {
    throw new TypeError('Array.prototype.findIndex called on null or undefined');
  } else if (typeof callback !== 'function') {
    throw new TypeError('callback must be a function');
  }
  var list = Object(this);
  // Makes sures is always has an positive integer as length.
  var length = list.length >>> 0;
  var thisArg = arguments[1];
  for (var i = 0; i < length; i++) {
    if ( callback.call(thisArg, list[i], i, list) ) {
      return i;
    }
  }
  return -1;
};

// Create Element.remove() function if not exist
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

function filenameToClass(extension){
    var lookup = {
        'doc': 'file-word',
        'docx': 'file-word',
        'xls': 'file-excel',
        'xlsx': 'file-excel',
        'csv': 'file-excel',
        'pptx': 'file-power-point',
        'pptm': 'file-power-point',
        'ppt': 'file-power-point',
        'pdf': 'file-pdf',
        'png': 'file-png',
        'jpg': 'file-jpg',
        'jpeg': 'file-jpg',
        'numbers': 'file-numbers',
        'pages': 'file-pages',
        'bmp': 'file-bmp',
        'mp3': 'file-mp3',
        'txt': 'file-txt',
    };

    extension = extension.toLowerCase();

    if (extension in lookup){
        return lookup[extension];
    }

    return null;
}

function downloadFile(data,fileName, type){
    if (!type){
        type = "text/csv;charset=utf-8;";
    }

    var blob = new Blob([data], {type: type});

    if (window.navigator.msSaveBlob) { // IE
        window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else { // Chrome
        var anchor = document.createElement('a');

        anchor.setAttribute('href', URL.createObjectURL(blob));
        anchor.setAttribute('download', fileName);
        anchor.setAttribute('target', '_blank');

        _.delay(function(){
            anchor.click();

            anchor.remove();
        }, 100);
    }
}

function getGravatarImageUrl (email, size, default_image, allowed_rating, force_default)
{
    email = typeof email !== 'undefined' ? email : 'john.doe@example.com';
    size = (size >= 1 && size <= 2048) ? size : 80;
    default_image = typeof default_image !== 'undefined' ? default_image : 'mm';
    allowed_rating = typeof allowed_rating !== 'undefined' ? allowed_rating : 'g';
    force_default = force_default === true ? 'y' : 'n';

    return ("https://secure.gravatar.com/avatar/" + md5(email.toLowerCase().trim()) + "?size=" + size + "&default=" + encodeURIComponent(default_image) + "&rating=" + allowed_rating + (force_default === 'y' ? "&forcedefault=" + force_default : ''));
}

function getGravatarUrl(email, size){
    return getGravatarImageUrl(email, size, "blank", "pg", false);
}

function markdownToHtml(markdown) {
    var boldRegex = new RegExp(/\*\*(\S[^\*]*\S)\*\*/img);
    var linkRegex = new RegExp(/\[([\w\s\d\S]+?)\]\((mailto:[\S]+?|https?:\/\/[\S]+?)\)/img);

    var result;

    var convertedResults = markdown;

    while ((result = linkRegex.exec(markdown)) !== null) {
        convertedResults = convertedResults.replace(result[0], "<a href='" + result[2] + "' target='_blank'>" + result[1] + "</a>");
    }

    while ((result = boldRegex.exec(markdown)) !== null) {
        convertedResults = convertedResults.replace(result[0], "<b>" + result[1] + "</b>");
    }

    return convertedResults.replace(/\n/g, "<br>");
}

function removeAllHtmlTags(text){
    if (!text){
        return text;
    }

    return text.replace(/<[^>]*>/img, "");
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
  };
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function reverseSortBy(sortByFunction) {
  return function(left, right) {
    var l = sortByFunction(left);
    var r = sortByFunction(right);

    if (l === void 0) return -1;
    if (r === void 0) return 1;

    return l < r ? 1 : l > r ? -1 : 0;
  };
}

// jquery extend function
$.extend(
{
    redirectPost: function(location, args)
    {
        var form = '';
        $.each( args, function( key, value ) {
            value = value.split('"').join('\"')
            form += '<input type="hidden" name="'+key+'" value="'+value+'">';
        });
        $('<form action="' + location + '" method="POST">' + form + '</form>').appendTo($(document.body)).submit();
    }
});

(function ($) {
    $.fn.inlineStyle = function (prop) {
        return this.prop("style")[$.camelCase(prop)];
    };
}($));

function csvSafe(s){
    if (!s){
        return "";
    }

    if (s.indexOf(",") === -1){
        return s;
    }

    return "\"" + s +  "\"";
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

function extractThemeComponents(theme){
    if (!theme){
        return null;
    }

    const re = /hsl:(\d+),(\d+)%?,(\d+)%?/i;

    const found = theme.match(re);

    if (found){
        return {'hue': found[1], 'saturation': found[2], 'lightness': found[3]};
    }

    return null;
}

function extractThemeComponentsFromStyle(theme){
    if (!theme){
        return null;
    }

    const re = /background: hsl\((\d+), (\d+)%, (\d+)%\)/i;

    const found = theme.match(re);

    if (found){
        return {'hue': found[1], 'saturation': found[2], 'lightness': found[3]};
    }

    return null;
}

function buildThemeFromComponents(hue, saturation, lightness){
    if (hue && saturation && lightness){
        return "hsl:" + hue + "," + saturation + "," + lightness;
    }

    return null;
}

function HSLToHex(h,s,l) {
  s /= 100;
  l /= 100;

  let c = (1 - Math.abs(2 * l - 1)) * s,
      x = c * (1 - Math.abs((h / 60) % 2 - 1)),
      m = l - c/2,
      r = 0,
      g = 0,
      b = 0;

  if (0 <= h && h < 60) {
    r = c; g = x; b = 0;
  } else if (60 <= h && h < 120) {
    r = x; g = c; b = 0;
  } else if (120 <= h && h < 180) {
    r = 0; g = c; b = x;
  } else if (180 <= h && h < 240) {
    r = 0; g = x; b = c;
  } else if (240 <= h && h < 300) {
    r = x; g = 0; b = c;
  } else if (300 <= h && h < 360) {
    r = c; g = 0; b = x;
  }
  // Having obtained RGB, convert channels to hex
  r = Math.round((r + m) * 255).toString(16);
  g = Math.round((g + m) * 255).toString(16);
  b = Math.round((b + m) * 255).toString(16);

  // Prepend 0s, if necessary
  if (r.length === 1)
    r = "0" + r;
  if (g.length === 1)
    g = "0" + g;
  if (b.length === 1)
    b = "0" + b;

  return "#" + r + g + b;
}

function hexToHSL(r, g, b) {
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r,g,b),
      cmax = Math.max(r,g,b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;

  if (delta === 0)
    h = 0;
  else if (cmax === r)
    h = ((g - b) / delta) % 6;
  else if (cmax === g)
    h = (b - r) / delta + 2;
  else
    h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0)
    h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return {'hue': h, 'saturation': s, 'lightness': l};
}

function getHslColor(imgElement){
    const colorThief = new ColorThief();

    var color = colorThief.getColor(imgElement);

    return hexToHSL(color[0], color[1], color[2])
}

Number.isInteger = Number.isInteger || function(value) {
    return typeof value === "number" &&
           isFinite(value) &&
           Math.floor(value) === value;
};

function getParameterByName(name, url) {
    if (!url){
        url = window.location.href;
    }

    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

$.fn.synchronizeScroll = function() {
    var elements = this;

    if (elements.length <= 1) return;

    function onScrollSynchronize() {
        var percentage = $(this).scrollTop() / (this.scrollHeight - this.offsetHeight);
        var scrollingEl = $(this);

        elements.each(function () {
            if ($(this) !== scrollingEl) {
                $(this).off('scroll', onScrollSynchronize);

                $(this).scrollTop(percentage * (this.scrollHeight - this.offsetHeight));

                var that = this;
                setTimeout( function(){
                    $(that).on('scroll', onScrollSynchronize);
                    },50);
            } else {
            }
        });
    }

    elements.scroll(function() {
        onScrollSynchronize.call(this);
    });
}

var getProp = function (obj, name) {
    var realName = _.findKey(obj, function (value, key) {
        return key.toLowerCase() === name.toLowerCase();
    });
    return obj[realName];
};

function initialiseRichTextEditor(selector){
    $(selector).trumbowyg({
        svgPath: '/static/images/trumbowyg-icons.svg',
        minimalLinks: true,
        imageWidthModalEdit: true,
        btnsDef: {
            // Create a new dropdown
            upload: {
                ico: 'insertImage'
            },
            justifyLeft: {
                        dropdown: ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    }
        },
        btns: [
            ['fontsize'],
            ['fontfamily'],
            ['strong', 'em', 'underline', 'del'],
            ['foreColor', 'backColor'],
            ['link'],
            ['upload'],
            ['justifyLeft'],
            ['unorderedList', 'orderedList'],
            ['removeformat']
        ],
        plugins: {
                upload: {
                    serverPath: '/attachment/upload',
                    fileFieldName: 'file',
                    urlPropertyName: 'imageUrl'
                },
                pasteimageupload: {},
                fontsize: {
                    allowCustomSize: false
                },
                fontfamily: {
                    fontList: [
                        {name: 'Sans Serif', family: 'Arial, Helvetica, sans-serif'},
                        {name: 'Serif', family: 'Times New Roman, Times, serif'},
                        {name: 'Fixed Width', family: 'Courier New, Courier, monospace'},
                        {name: 'Wide', family: 'Arial Black, Gadget, sans-serif'},
                        {name: 'Comic Sans', family: 'Comic Sans MS, Textile, cursive, sans-serif'},
                        {name: 'Georgia', family: 'Georgia, serif'},
                        {name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif'},
                        {name: 'Trebuchet', family: 'Trebuchet MS, Helvetica, sans-serif'},
                        {name: 'Verdana', family: 'Verdana, Geneva, sans-serif'}
                    ]
                }
            }
    });
}

function initialiseRichTextSignatureEditor(selector){
    $(selector).trumbowyg({
        svgPath: '/static/images/trumbowyg-icons.svg',
        minimalLinks: true,
        imageWidthModalEdit: true,
        btnsDef: {
            // Create a new dropdown
            base64: {
                ico: 'insertImage'
            },
            justifyLeft: {
                        dropdown: ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    }
        },
        btns: [
            ['fontsize'],
            ['fontfamily'],
            ['strong', 'em', 'underline', 'del'],
            ['foreColor', 'backColor'],
            ['link'],
            ['base64'],
            ['justifyLeft'],
            ['unorderedList'],
            ['viewHTML']
        ],
        plugins: {
                upload: {
                    serverPath: '/attachment/upload',
                    fileFieldName: 'file',
                    urlPropertyName: 'imageUrl'
                },
                pasteimage: {},
                fontsize: {
                    allowCustomSize: false
                },
                fontfamily: {
                    fontList: [
                        {name: 'Sans Serif', family: 'Arial, Helvetica, sans-serif'},
                        {name: 'Serif', family: 'Times New Roman, Times, serif'},
                        {name: 'Fixed Width', family: 'Courier New, Courier, monospace'},
                        {name: 'Wide', family: 'Arial Black, Gadget, sans-serif'},
                        {name: 'Comic Sans', family: 'Comic Sans MS, Textile, cursive, sans-serif'},
                        {name: 'Georgia', family: 'Georgia, serif'},
                        {name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif'},
                        {name: 'Trebuchet', family: 'Trebuchet MS, Helvetica, sans-serif'},
                        {name: 'Verdana', family: 'Verdana, Geneva, sans-serif'}
                    ]
                }
            }
    });
}

function initialiseRichTextMessageEditor(selector){
    $(selector).trumbowyg({
        svgPath: '/static/images/trumbowyg-icons.svg',
        minimalLinks: true,
        imageWidthModalEdit: true,
        autogrow: true,
        btnsDef: {
            // Create a new dropdown
            base64: {
                ico: 'insertImage'
            },
            justifyLeft: {
                        dropdown: ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    }
        },
        btns: [
            ['fontsize'],
            ['fontfamily'],
            ['strong', 'em', 'underline', 'del'],
            ['foreColor', 'backColor'],
            ['link'],
            ['base64'],
            ['justifyLeft'],
            ['unorderedList'],
            ['viewHTML']
        ],
        plugins: {
                upload: {
                    serverPath: '/attachment/upload',
                    fileFieldName: 'file',
                    urlPropertyName: 'imageUrl'
                },
                pasteimage: {},
                fontsize: {
                    allowCustomSize: true,
                    sizeList: [
                        '12px',
                        '14px',
                        '20px',
                    ]
                },
                fontfamily: {
                    fontList: [
                        {name: 'Sans Serif', family: 'Arial, Helvetica, sans-serif'},
                        {name: 'Serif', family: 'Times New Roman, Times, serif'},
                        {name: 'Fixed Width', family: 'Courier New, Courier, monospace'},
                        {name: 'Wide', family: 'Arial Black, Gadget, sans-serif'},
                        {name: 'Comic Sans', family: 'Comic Sans MS, Textile, cursive, sans-serif'},
                        {name: 'Georgia', family: 'Georgia, serif'},
                        {name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif'},
                        {name: 'Trebuchet', family: 'Trebuchet MS, Helvetica, sans-serif'},
                        {name: 'Verdana', family: 'Verdana, Geneva, sans-serif'}
                    ]
                }
            }
    });
}

function setEditorContent(editor, content){
    if (!content){
        content = "";
    }

    editor.trumbowyg('html', content);
}

function getQuillContent(editor){
    var editorContent = editor.trumbowyg('html');

    if (editorContent === false){
        Materialize.toast('Editor not initialised', 2000, "materialize-red lighten-2");

        throw new Error('trumbowyg editor returned false');
    }

    var contentEl = $("<div>" + editorContent + "</div>");

    contentEl.find('p').replaceWith(function(){
        var newDiv = $('<div/>', {
            html: this.innerHTML
        });

        newDiv.prop('style', $(this).attr('style'));

        return newDiv;
    });

    contentEl.find('img').each(function (){
        if (!$(this).inlineStyle('max-width')){
            $(this).css('max-width', '100%');
        }
    });

    return contentEl.html();
}

function setEditorHeight(editor, height){
    editor.closest(".trumbowyg-box").css("min-height", height);
    editor.prev(".trumbowyg-editor").css("min-height", height);
    editor.css("min-height", height); // <-- This fixes the raw HTML editor
}


function buildReplyText(model){
    var msg = $('<div/>').html(model.get("htmlMessage"));

    msg.find('style').remove();
    msg.find('base').remove();
    msg.find('title').remove();

    var body = msg.find('body');

    var replyDateTime = replyToMessageFormat(model.get('created'));
    var replyBreak = '<br><div><br>On ' + replyDateTime + ', ' + model.get('from_name') + ' &lt;<a href="mailto:' + model.get('from_email') + '">' + model.get('from_email') + '</a>&gt; wrote:<br><br></div>';

    var editorText = '';

    if (body.length > 0) {
        editorText = replyBreak + "<blockquote>" + body.html() + "</blockquote><br/><br/>";
    } else {
        editorText = replyBreak + "<blockquote>" + msg.html() + "</blockquote><br/><br/>";
    }

    if (window.ManageView.memModel) {
        if (window.ManageView.memModel.get('use_signature') && window.ManageView.memModel.get('signature_text')){
            editorText = "<br><br>--<br>" + window.ManageView.memModel.get('signature_text') + editorText;
        }
    }

    return editorText;
}

$.all = function (promises) {
    if (!Array.isArray(promises)) {
        throw new Error("$.all() must be passed an array of promises");
    }
    return $.when.apply($, promises).then(function () {
        // if single argument was expanded into multiple arguments, then put it back into an array
        // for consistency
        if (promises.length === 1 && arguments.length > 1) {
            // put arguments into an array
            return [Array.prototype.slice.call(arguments, 0)];
        } else {
            return Array.prototype.slice.call(arguments, 0);
        }
    })
};

Object.values = Object.values || function(o){return Object.keys(o).map(function(k){return o[k]})};

export function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
